export default "__VITE_ASSET__Bzoc6UVi__"